<form *ngIf="form" [formGroup]="form">
  <dx-lookup
    formControlName="overheadId"
    formField
    required
    [label]="'breadcrumb.overheads' | translate | ucfirst"
    [dataSource]="overheadsForPick"
    displayExpr="description"
    valueExpr="id"
    [searchEnabled]="true"
    pageLoadMode="nextButton"
  />
</form>
